import * as React from "react";
import "./primaryNavBar.css";

const PrimaryNavBar = () => {
  return (
    <div className="primary-navbar">
      <div className="text-medium">
        Courses taught by industry leaders around the world
      </div>
    </div>
  );
};

export default PrimaryNavBar;
